import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_COUNTRY,
  ADD_COUNTRY,
  UPDATE_COUNTRY,
  DELETE_COUNTRY,
  
} from "./actionTypes"

import {

  getCountryListSuccess,
  addCountrySuccess,
  updateCountrySuccess,
  deleteCountrySuccess,
  apiCountryApiError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addCountry,
updateCountry,
deleteCountry,
getCountryList

} from "../../helpers/backend_helper/backend_helper"


function* onGetCountryList() {
  try {
    const response = yield call(getCountryList)
    yield put(getCountryListSuccess(response))
  } catch (error) {
    yield put(apiCountryApiError(error))
  }
}

function* onAddCountry({ payload: record }) {
  try {
    const response = yield call(addCountry, record)
    yield put(addCountrySuccess(response))
  } catch (error) {
    yield put(apiCountryApiError(error))
  }
}

function* onUpdateCountry({ payload: record }) {
  try {
    const response = yield call(updateCountry, record)
    yield put(updateCountrySuccess(response))
  } catch (error) {
    yield put(apiCountryApiError(error))
  }
}

function* onDeleteCountry({ payload: guid }) {
  try {
    const response = yield call(deleteCountry, guid)
    yield put(deleteCountrySuccess(response))
  } catch (error) {
    yield put(apiCountryApiError(error))
  }
}


function* countryManagementSaga() {

    yield takeEvery(GET_COUNTRY,onGetCountryList)
    yield takeEvery(ADD_COUNTRY,onAddCountry)
    yield takeEvery(UPDATE_COUNTRY,onUpdateCountry)
    yield takeEvery(DELETE_COUNTRY,onDeleteCountry)
}

export default countryManagementSaga
